import { Signal } from '@angular/core';
import { PermissionType, TRole } from './security.types';

//#region View Designs

export type TViewMapItem<TViewCategory = unknown, TView = unknown> = {
  viewCategory: TViewCategory;
  views: Array<TView>;
};

export type TViewMap<TViewCategory = unknown, TView = unknown> = Array<
  TViewMapItem<TViewCategory, TView>
>;

export type TViewItem<T> = {
  control: string;
  settings: {
    tag: string;
    label: string;
    headerIsHidden?: boolean;
    disabled?: boolean;
    options?: Array<T> | Signal<Array<T>>;
    optionsSorting?: boolean;
    optionsFiltering?: boolean;
    optionGroup?: string;
  } & T;
  class?: string;
  uiloading?: string;
  contentCssClass?: string;
  contentinput?: string;
  content?: Array<TViewItem<T>>;
  omitRender?: boolean;
};

//#endregion

// #region Permissions

export type TPermission = {
  tag: string;
  applyToCollection?: boolean;
  claims: Array<{
    views?: Array<string>;
    roles: Array<TRole>;
    categories?: Array<string>;
    rights: PermissionType;
  }>;
};

// #endregion

//#region Tags

export type TTagField = {
  tag: string;
  field: string;
  entityTypeId?: number;
  $isEditing?: boolean;
};

// #endregion
